import gql from 'graphql-tag'
import { fragPostSearch, fragPostSummary } from '../fragments/post.js'
import { fragPageInfo } from '../fragments/seo.js'

export const querySearch = gql`
  ${fragPostSearch}
  ${fragPageInfo}
  query QuerySearch(
    $where: RootQueryToPostConnectionWhereArgs
    $endCursor: String
    $first: Int = 8
  ) {
    posts(where: $where, after: $endCursor, first: $first) {
      edges {
        node {
          ...FragPostSearch
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
  }
`

export const queryLatestPosts = gql`
  ${fragPostSummary}
  query QueryLatestPosts($first: Int = 15) {
    posts(first: $first) {
      edges {
        node {
          ...FragPostSummary
        }
      }
    }
  }
`
